<template>
  <div class="empty-state-container">
    <v-icon v-if="icon" class="empty-state-icon" :color="iconColor">{{ icon }}</v-icon>
    <h3 v-if="title" class="empty-state-title">{{ title }}</h3>
    <p class="empty-state-text">{{ message }}</p>
    <v-btn v-if="actionText" color="primary" @click="$emit('action')" class="mt-4">
      {{ actionText }}
    </v-btn>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "EmptyState",
  props: {
    title: {
      type: String,
      default: ""
    },
    message: {
      type: String,
      default: "No data available"
    },
    icon: {
      type: String,
      default: "mdi-alert-circle"
    },
    iconColor: {
      type: String,
      default: "grey darken-1"
    },
    actionText: {
      type: String,
      default: ""
    }
  }
};
</script>

<style scoped>
.empty-state-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  min-height: 150px;
}

.empty-state-icon {
  font-size: 42px;
  margin-bottom: 1rem;
}

.empty-state-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 0.75rem;
  color: #333;
}

.empty-state-text {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.6);
  text-align: center;
  font-weight: 500;
}
</style> 